import React, { useEffect, useState } from 'react';
import AdminTable from 'common/AdminTable';
import { getRequest, deleteRequest } from 'apis/ApiInstence';
import { FaTrash } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const ListVideo = () => {
  const [videoData, setVideoData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchVideos = async () => {
    try {
      const response = await getRequest('videos');
      if (response?.data) {
        setVideoData(response.data);
      } else {
        setVideoData([]);
      }
    } catch (error) {
      console.error('Error fetching videos:', error);
      setVideoData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this video?')) {
      try {
        const response = await deleteRequest(`videos/${id}`);
        if (response?.status === 200) {
          setVideoData((prev) => prev.filter((vid) => vid.id !== id));
        } else {
          alert('Failed to delete video.');
        }
      } catch (error) {
        console.error('Error deleting video:', error);
        alert('Failed to delete video.');
      }
    }
  };

  const getYoutubeId = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  };

  const tableHeaders = [
    { Header: 'ID', accessor: 'id' },
    { Header: 'Title', accessor: 'title' },
    { 
      Header: 'URL', 
      accessor: 'url',
      Cell: ({ row }) => (
        <a href={row.original.url} target="_blank" rel="noopener noreferrer">
          {row.original.url}
        </a>
      )
    },
    {
      Header: 'Thumbnail',
      accessor: 'thumbnail',
      Cell: ({ row }) => {
        const videoId = getYoutubeId(row.original.url);
        const thumbnailUrl = videoId
          ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
          : 'https://via.placeholder.com/120?text=No+Thumbnail';

        return (
          <img
            src={thumbnailUrl}
            alt={row.original.title}
            width={120}
            height={68}
            style={{ objectFit: 'cover', borderRadius: 8 }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = 'https://via.placeholder.com/120?text=No+Thumbnail';
            }}
          />
        );
      },
    },
    {
      Header: 'Action',
      accessor: 'action',
      Cell: ({ row }) => (
        <button
          className="btn btn-danger btn-sm"
          onClick={() => handleDelete(row.original.id)}
        >
          <FaTrash /> Delete
        </button>
      ),
    },
  ];

  useEffect(() => {
    fetchVideos();
  }, []);

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4 d-flex justify-content-between align-items-center mb-4">
        <h4 className="text-white font-weight-bold mb-0">Video List</h4>
        <Link className="btn btn-light font-weight-bold shadow-sm" to="/gallery/video/add" style={{ borderRadius: '8px', padding: '8px 16px', color: '#015198' }}>
          <i className="fa fa-plus mr-2"></i>
          Add New Video
        </Link>
      </div>

      {loading ? (
        <div className="text-white text-center mt-4">Loading...</div>
      ) : videoData.length > 0 ? (
        <AdminTable tableHeaders={tableHeaders} tableData={videoData} />
      ) : (
        <div className="text-white text-center mt-4">No videos found.</div>
      )}
    </div>
  );
};

export default ListVideo;
